import { getComponentById } from '../../../redux/component/component-selectors'
import { Button } from '../../../atoms'
import React from 'react'
import { brand, query } from '../../../redux/app-selectors'
import { connect } from 'react-redux'
import Image from '../../imgix-img'
import classNames from 'classnames'

const usps = {
  '1ffe7e07-8515-4b37-bda7-efd1ca2f3f28':
    'Get started with no monthly fee and get a decision in minutes. Streamline your business finances today.',
  '0c1a0c32-905c-4374-b56c-4f831684346e':
    'Kick start your business and build your business credit score at the same time.',
  '5a91871c-d265-406a-87d5-78093a180bc2':
    'Get a tailored quote in four minutes and protect your business against a range of events.',
  'b0e5886e-e063-4212-8e3a-9b21571003e6':
    'Grab a card payment solution to suit your business and never miss a sale.',
  'bfc942f5-e822-4772-8419-ff8f780ccb65':
    'Earn a competitive interest rate on your business’s income and protect money you’re saving for later.',
  'cfcb1a3f-bba3-49ba-8c8c-bc0b1a8ac706':
    'Get access to Tide’s instant access rate and use tide to integrate seamlessly with the rest of your business',
  '471cb881-2c77-4a24-94a6-ff69392a5d86':
    'Get double cashback – now 2% – uncapped* for three months. Apply by 2 April 2024. T&Cs apply',
}

const uspField = {
  startup: 'usp_starting_business',
  mid: 'usp_scaling_business',
  large: 'usp_sustaining_business',
}

const SelectedBundle = ({ bundleData, businessBundle, jsonBody }) => {
  const { resultsBundle } = jsonBody
  if (!businessBundle) {
    return <></>
  }
  return (
    <div className={`SelectedBundle SelectedBundle__${businessBundle}`}>
      <div
        className={classNames('SelectedBundle__header', {
          'SelectedBundle__header--center': resultsBundle,
        })}
      >
        <h3>{resultsBundle ? 'Your bundle is ready!' : 'Your selected bundle'}</h3>
        {!resultsBundle && (
          <Button variant='tertiary' size='sm' dataAction='change-bundle-cta'>
            Change bundle
          </Button>
        )}
      </div>
      <p className='SelectedBundle__type'>
        {businessBundle === 'startup'
          ? 'The Start-up'
          : businessBundle === 'mid'
          ? 'Scaling your business'
          : 'Sustaining your business'}
      </p>
      <div className='SelectedBundle__products'>
        {bundleData.map((bundle, key) => {
          return (
            bundle && (
              <div className='SelectedBundle__product' key={key}>
                <div className='SelectedBundle__product__wrapper' key={key}>
                  <div className='SelectedBundle__product__img'>
                    <Image
                      src={
                        bundle._source.definition.product_image_money ??
                        bundle._source.definition.provider.logo.money
                      }
                    />
                  </div>
                  <div className='SelectedBundle__product__info'>
                    <p className='SelectedBundle__product__info__title'>
                      {' '}
                      {bundle._source.definition.display_name}
                    </p>
                    <p className='SelectedBundle__product__info__text'>
                      {bundle._source.definition[uspField[businessBundle]] ??
                        usps[bundle._source.id]}
                    </p>
                  </div>
                </div>
                <div className='SelectedBundle__cta'>
                  {resultsBundle && (
                    <Button
                      withIcon={true}
                      variant='primary'
                      size='md'
                      href={bundle._source.links.money.default.destination_url}
                      openInNewTab={true}
                    >
                      View deal
                    </Button>
                  )}
                </div>
              </div>
            )
          )
        })}
      </div>
    </div>
  )
}
export default connect((state, props) => {
  return {
    bundleData: getComponentById(state, props.sys.id)?.bundleData,
    brand: brand(state),
    businessBundle: query(state)?.businessBundle ?? props.jsonBody.bundleType,
    ...props,
  }
})(SelectedBundle)
